import { render, staticRenderFns } from "./tianBaoB.vue?vue&type=template&id=9afb364e&scoped=true&"
import script from "./tianBaoB.vue?vue&type=script&lang=js&"
export * from "./tianBaoB.vue?vue&type=script&lang=js&"
import style0 from "./tianBaoB.vue?vue&type=style&index=0&id=9afb364e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9afb364e",
  null
  
)

export default component.exports